(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-prefers-reduced-motion.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-prefers-reduced-motion.js');
"use strict";


const {
  useEffect,
  useState
} = React;
const usePrefersReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handleChange = () => {
      setPrefersReducedMotion(mediaQuery.matches);
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  return prefersReducedMotion;
};
setGlobal('svs.components.poolBetting.hooks.usePrefersReducedMotion', usePrefersReducedMotion);

 })(window);